import { render } from "./StudentDemeritsDialog.vue?vue&type=template&id=6c877e0d&scoped=true"
import script from "./StudentDemeritsDialog.vue?vue&type=script&lang=js"
export * from "./StudentDemeritsDialog.vue?vue&type=script&lang=js"

import "./StudentDemeritsDialog.vue?vue&type=style&index=0&id=6c877e0d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c877e0d"]])

export default __exports__